import Navigation from '../Navigation/Navigation'
import Footer from '../Footer/Footer'
import { LayoutProps } from './Layout.type'
import './Layout.scss'

const Layout: React.FC<LayoutProps> = ({ children }) => {
	return (
		<div className='layout'>
			<Navigation />
			<main className='main'>{children}</main>
			<Footer />
		</div>
	)
}

export default Layout
